import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateEarmarkDetailsReduxParam } from '~types/feat/gold';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchUpdateEarmarkDetails(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldUpdateEarmarkDetailsAttempt', handleUpdateEarmarkDetails, api);
}

function* handleUpdateEarmarkDetails(api: GoldGateway, data: PayloadAction<TUpdateEarmarkDetailsReduxParam>) {
    const authToken = store.getState().auth.userDetails.authToken;
    const { transactionId, earmarkEndDate } = data.payload;

    if (!transactionId || !earmarkEndDate) {
        yield put(combinedActions.goldUpdateEarmarkDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.updateEarmarkDetails], {
        authToken,
        transactionId,
        earmarkEndDate,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldUpdateEarmarkDetailsFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldUpdateEarmarkDetailsSuccess());
    }
}
